import { ErrorReason } from '@shared/models/error/error-reason';
import { EgiErrorCode } from '@data/_generated-api/error-mappers/egi-error-code';

export class ErrorInformation<TExtra = string> {
  constructor(
    public readonly message: string,
    public readonly reason: ErrorReason,
    public readonly additionalInfo?: TExtra
  ) {}

  public errorCode: EgiErrorCode = EgiErrorCode.Default;

  public static createDefault(): ErrorInformation {
    return new ErrorInformation('', ErrorReason.ApplicationError, '');
  }

  public static unimplemented(): ErrorInformation {
    return new ErrorInformation(
      'The operation is not yet implemented',
      ErrorReason.Unimplemented,
      ''
    );
  }

  static serverDown(): ErrorInformation {
    return new ErrorInformation('The server is not available', ErrorReason.Unavailable, '');
  }

  static userCancelled(): ErrorInformation {
    return new ErrorInformation<string>('', ErrorReason.UserCanceled);
  }
}
